import { analytics } from '@/common/logs/EventLogger';
import { waitDialog } from '../waitDialog';

// Sync logs before session end in async way, so their promises can be awaited.
// During that time we show dialog with "Please wait" message.
export const syncLogs = async ({
  promises = [],
  endSession = true,
}: {
  promises?: Promise<any>[];
  endSession?: boolean;
} = {}) => {
  endSession && analytics.trackSessionEndEvent();

  const analyticsPromise = (async () => {
    // Wait for all provided promises and flushLogs to finish
    await Promise.all([...promises, analytics.flushLogs()]);

    // Then execute trackSessionEnd
    endSession && (await analytics.trackSessionEnd());
  })();

  await waitDialog({
    promise: analyticsPromise,
    timeout: analytics.MAX_REQUEST_WAITING_MS,
  });
};
